/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbLeadTime_item" | "PdpRespSidebarBlurbShipping_item">;
    readonly " $refType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$data = PdpRespSidebarBlurbs_item;
export type PdpRespSidebarBlurbs_item$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbLeadTime_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '09bf53e753bf71b43777abc1c897c1e5';
export default node;
